import {
  FETCH_AUDITTRAILLIST_REQUEST,
  FETCH_AUDITTRAILLIST_SUCCESS,
  FETCH_AUDITTRAILLIST_FAILURE,
} from "./inventoryAuditTrailTypes";

const initialState = {
  loading: false,
  auditList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AUDITTRAILLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_AUDITTRAILLIST_SUCCESS:
      return {
        loading: false,
        auditList: action.payload,
        error: "",
      };
    case FETCH_AUDITTRAILLIST_FAILURE:
      return {
        loading: false,
        auditList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
